import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { useTranslations } from 'hooks/useTranslations';

interface IFRTCard {
  data: ITableDataSource;
  handleSelect?: () => void;
  handleView?: (args: string) => void;
}

const FRTCard = ({ data, handleSelect, handleView }: IFRTCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: colors.gray200,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid sx={{ p: 2 }} size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('firearmsReferenceTable.accordion.make.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.make)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }} size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('firearmsReferenceTable.accordion.model.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.model)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }} size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('firearmsReferenceTable.accordion.manufacturer.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.manufacturer)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }} size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('firearmsReferenceTable.accordion.firearmAction.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.action)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }} size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('firearmsReferenceTable.accordion.type.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.type)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }} size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('firearmsReferenceTable.accordion.country.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.country)}</Typography>
      </Grid>

      <Grid container size={{ xs: 12 }} sx={{
        p: 2, borderTop: {
          xs: `1px solid ${colors.primary100}`,
          lg: 'none',
        }
      }}>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ mb: { xs: 2, sm: 0 } }}>
          <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
            {t('general.actions.button')}:
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 9 }}>
          {handleSelect && (
            <Button
              label={t('general.select.text')}
              variant={EButtonVariants.outlined}
              onClick={handleSelect}
              size="small"
              fullWidth
            />
          )}
          {handleView && (
            <Button
              label={t('general.details.text')}
              variant={EButtonVariants.outlined}
              onClick={() => handleView(data.id as string)}
              size="small"
              fullWidth
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export { FRTCard };
